import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getTaskPresignedUploadUrl } from '../redux/actions/tasks';
import { validateTaskFile, TASK_MAX_ATTACHMENTS } from '../common/taskUploads';
import { useR2UploadQueue } from './useR2UploadQueue';

export const useTaskAttachments = (courseId, { maxFiles = TASK_MAX_ATTACHMENTS } = {}) => {
    const dispatch = useDispatch();

    const requestPresign = useCallback((file, mimeType) => {
        if (!courseId) {
            return Promise.reject(new Error('No hay curso activo.'));
        }
        return dispatch(getTaskPresignedUploadUrl(courseId, {
            fileName: file.name,
            mimeType,
            size: file.size,
        }));
    }, [courseId, dispatch]);

    return useR2UploadQueue({
        validateFile: validateTaskFile,
        requestPresign,
        maxFiles,
    });
};
